import { render, staticRenderFns } from "./PDPCommentNode.vue?vue&type=template&id=3435976c&scoped=true&"
import script from "./PDPCommentNode.vue?vue&type=script&lang=js&"
export * from "./PDPCommentNode.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentNode.vue?vue&type=style&index=0&id=3435976c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3435976c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PDPCommentStatusTag: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentStatusTag.vue').default,PDPCommentRatings: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentRatings.vue').default,PDPCommentBody: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentBody.vue').default,PDPUserProfile: require('/app/appsumo/nuxt/components/pdp/comment/PDPUserProfile.vue').default,PDPCommentButtons: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentButtons.vue').default,PDPCommentControls: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentControls.vue').default,PDPCommentNode: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentNode.vue').default})
